import { createGlobalStyle } from 'styled-components';

import 'semantic-ui-css/semantic.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import colors from './colors';

export default createGlobalStyle`
  *{
    margin: 0;
    padding:0;
    outline: 0;
    box-sizing: border-box;
  }

  *:focus {
    outline: 0;
  }

  html, body, #root {
    height: 100%;
    color: #4d4d4d;
    background: ${colors.white};
  }

  body {
    -webkit-font-smoothing: antialiased;
  }

  body, input, button {
    font: 14px 'Exo 2', sans-serif;
  }

  h1, h2, h3, h4, h5, h6, p, span {
    font-family: 'Exo 2', sans-serif;
  }

  a {
    text-decoration: none;
    color: #006e99;
  }

  ul {
    list-style: none
  }

  button {
    cursor: pointer
  }

  [disabled] {
    cursor: not-allowed;
  }
`;
